export default [
  {
    id: 1,
    title: '年輕人是大選關鍵選民？',
    subtitle: '民進黨未必占優勢 都市化程度決定投票率',
    description: '年輕人投票有軌跡，政黨要爭取年輕人選票，得換個方式深入陣營。都市化程度造成不同投票率結果，越都市越好投？數據會告訴你真相，別再迷信年輕人一定支持／不支持特定政黨，真的蹲下來聽年輕人的需求和心聲，才能吸引這群異鄉打拚者。',
    image: require('@/assets/articles/article-1-cover.jpg')
  },
  {
    id: 2,
    title: '首投族改變選舉結果？',
    subtitle: '要搶首投族 先拚藍綠執政縣市動員',
    description: '【一鼓作氣】首投族嘗鮮投票衝出超高投票率。【再而衰】，投過一次再投一次，這群人比率只有一半。【三而竭】，投票成本居高不下，等社會新鮮人站穩腳跟，才會重新回到政治參與的戰場。',
    image: require('@/assets/articles/article-2-cover.jpg')
  },
  {
    id: 3,
    title: '虛擬空間的數位戰場',
    subtitle: '社群媒體 蔡韓柯各領風騷',
    description: '虛擬空間的數位戰場。Dcard使用群最年輕，蔡英文親訪強攻；IG經營柯文哲粉絲數近百萬，韓國瑜不到十萬，也反應出參選人在年輕族群受歡迎程度。各陣營鎖定經營核心Facebook，使用者觸及年齡層最廣，除了粉絲數累積競賽，小編還得斟酌發文時間，力拚流量極大化。',
    image: require('@/assets/articles/article-3-cover.jpg')
  },
  {
    id: 4,
    title: '年輕人內心話',
    subtitle: '在意參選人特質 更重視政策帶來希望',
    description: '大選就是政策溫度計。不愛韓國瑜、質疑蔡英文，年輕人會檢視參選人的言行和執政成績。指韓國瑜頻頻失言太唬爛，蔡英文的民進黨操作反送中賺選票，大家都看在眼裡。兩人都讓人有投不下去的理由，接下來要看個別候選人在青年政策上的著墨，年輕人沒有希望感，執政者知道嗎？',
    image: require('@/assets/articles/article-4-cover.jpg')
  }
]
